import { Image, Text, View } from 'components';
import Base, { Config } from 'components/rent/Base';
import React from 'react';
import styles from './index.module.scss';


const LEVEL_SILVER = 1
const LEVEL_GOLD = 2
const LEVEL_KING = 3   //2022-05-18 新增

const COLUMN_LIST = [
  {column: "score", name: '赠送积分', alia: '（抢好活用）',
    display: (obj:any) => {
      return (obj.value || '')+'积分'
    }
  },
  {column: "law", name: '律师在线法务咨询',
    display: (obj:any) => {
      return (obj.value || '')+'次/年'
    }
  },
  {column: "box", name: '智能云盒打折购买',
    display: (obj:any) => {
      return obj.value? (obj.value+'折'): '免费送一台'
    }
  },
  {column: "bill", name: '工程机械记账功能'},
  {column: "course", name: '挖机维修视频课'},
  {column: "expert", name: '维修故障咨询2次'},
  {column: "fault", name: '故障代码+解决方案'},
  {column: "pact", name: '律师打造租赁合同'},
  {column: "icon", name: '专属钻石机主标识'},
  {column: "insurance", name: '设备险保费折扣', 
    display: (obj:any) => {
      return (obj.value || '')+'折'
    }
  },
  {column: "quality", name: '专属优质项目'},
  {column: "tender", name: '新开工地信息'},
  {column: "subCall", name: '项目电话免费拨打', 
    display: (obj:any, level:1 | 2 | 3) => {
      return level+'年内'
    }
  },
  {column: "uploadVideo", name: '上传设备视频功能'},
  {column: "push", name: '名录、设备优先展示'},
]


interface State {
  vipList: {
    days: number
    id: number
    info_list: any
    level: number   //1：银会员；   2：金会员  3皇冠会员
    // type: number    //1长期；  2替班
    name: string
    price: string
    cost: string
    status: number
  }[]
  currentLevel: 1 | 2  //当前选中的
  vipInfo: any,
}

export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    vipList: [],
    currentLevel: LEVEL_GOLD,
    vipInfo: {},
  };

  public async didMount() {
    // await this.getUserInfo();
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const col = (this.props.location.state || {})
    this.setState({
      // type: params.type || col || 1,
    })


    this.init(params)
  }

  public render() {
    const { currentLevel, vipInfo, vipList } = this.state;

    return vipList.length > 0? (
      <View className={styles.container} style={{backgroundImage: 'url('+this.assets.sixshot.vipCompaireBg+')'}}>
        
        <View className={styles.lists}>
          <View className={styles.title}>会员权益对比</View>
          <View className={styles.th}>
            <View className={styles.sp1}>特权</View>
              <View className={styles.sp2}>银钻1年</View>
              <View className={styles.sp3}>金钻2年</View>
              <View className={styles.sp3}>皇冠3年</View>
          </View>


          {this.FilterColumnList.map(res => {
            const goldRes = ((this.vipGold.info_list || []).find(e => e.column == res.column) || {})
            const silvRes = ((this.vipSilver.info_list || []).find(e => e.column == res.column) || {})
            const kingRes = ((this.vipKing.info_list || []).find(e => e.column == res.column) || {})
            return (
              <View className={styles.td} key={res.column}
                style={res.column == 'score'? {height: '50px'}: {}}
              >
                <Text className={styles.sp1}>{res.name}<Text className={styles.alia}>{res.alia}</Text></Text>
                <View className={styles.sp2}>
                  {!silvRes.status? '/': res.display? 
                    res.display(silvRes, LEVEL_SILVER): '有'
                  }
                  {res.column == 'score' && 
                    <View className={styles.tg}>价值{silvRes.price}元</View>
                  }
                </View>
                <View className={styles.sp3}>
                  <Text className={res.column == 'score'? styles.red: ''}>
                    {
                      !goldRes.status? '/':
                        res.display? 
                          res.display(goldRes, LEVEL_GOLD): '有'
                    }
                  </Text>
                  {res.column == 'score' && 
                    <View className={this.cx(styles.tg, styles.red)}>价值{goldRes.price}元</View>
                  }
                </View>
                <View className={styles.sp3}>
                  <Text className={res.column == 'score'? styles.red: ''}>
                    {
                      !kingRes.status? '/':
                        res.display? 
                          res.display(kingRes, LEVEL_KING): '有'
                    }
                  </Text>
                  {res.column == 'score' && 
                    <View className={this.cx(styles.tg, styles.red)}>价值{kingRes.price}元</View>
                  }
                </View>
              </View>
            )
          })}


          
        </View>

        <View className={styles.bottomFixed}>
          <View className={styles.btnBack} onClick={this.handleBack} style={{
            marginBottom: '40px'
          }}>点此返回</View>
          {this.vipGold && 
            <View className={this.cx(styles.bottomBtns)} style={{display: 'none'}}>
              {[this.vipSilver, this.vipGold, this.vipKing].map((res, ind) => (
                <View className={this.cx(styles.btn, {
                  [styles.active]: res.level == currentLevel
                })} key={ind} onClick={this.handleClickPay.bind(null, res)}>
                  {res.level == LEVEL_GOLD && <View className={styles.limit}>限时</View>}
                  <View className={styles.tit}>
                    <Text className={styles.h2}>{res.name}</Text>
                  </View>
                  <View className={styles.price}>
                    <Text className={styles.sm}>￥</Text>
                    <Text>{Number(res.price || 0)}</Text>
                    <Text className={styles.p}>{'点此支付>>'}</Text>
                  </View>
                </View>
              ))}
            </View>
          }
          <View className={styles.noticeBox} style={{display: 'none'}}>购买须知：虚拟服务不支持退订、转让、退换，请斟酌确认！</View>
        </View>

      </View>
    ): '';
  }

  private get vipKing() {
    const { vipList } = this.state
    let res:any = vipList.find(e => e.level == LEVEL_KING) || {}
    return {...res, alias: '皇冠'}
  }
  private get vipGold() {
    const { vipList } = this.state
    let res:any = vipList.find(e => (e.level == LEVEL_GOLD)) || {}
    return {...res, alias: '金钻'}
  }
  private get vipSilver() {
    const { vipList } = this.state
    let res:any =  vipList.find(e => (e.level == LEVEL_SILVER)) || {}
    return {...res, alias: '银钻'}
  }
  private get vipSelected() {
    const { vipList, currentLevel } = this.state
    let res:any =  vipList.find(e => (e.level == currentLevel)) || {}
    return res
  }
  private get vipInfoGold() {
    return this.vipGold? this.vipGold.info_list || []: []
  }
  private get vipInfoSilv() {
    return this.vipSilver? this.vipSilver.info_list || []: []
  }

  private get FilterColumnList() {
    //重整后的列表顺序
    let result:any[] = []
    this.vipInfoGold.map(res => {
      const a = COLUMN_LIST.find(e => e.column == res.column) || null
      if(a){
        result.push({
          ...res,
          ...a
        })
      }
    })
    return result
  }

  private get isMiniProgram() {
    return this.interface.uaEnv.isWechatMp()
  }




  private handleBack = () => {
    if(this.isMiniProgram){
      window.wx.miniProgram.navigateBack()
    }else {
      this.navigator.back()
    }
  }

  private handleClickPay = (obj) => {
    this.setState({
      currentLevel: obj.level
    })
    
    if(this.isMiniProgram) {
      window.wx.miniProgram.redirectTo({url: '/pages/vip/webview/index?type=compaire&payId='+obj.id})
    }else {
      this.handlePay(obj.id)
    }
  }

  private handlePay = async (id) => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.vipPlusBuy({
      id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功');

      }
    });
  }


  private getUserInfo = async () => {
    // const { body } = await this.apiClient.base.userinfo();

    // const res = await this.apiClient.base.vipPlusInfo()
    // this.setState({
    //   vipInfo: body
    // })
  }

  private getVipLists = async() => {
    const { body } = await this.apiClient.base.vipPlus({})
    if(body) {
      this.setState({
        vipList: body || []
      })
    }
  }  

  private init = async (params) => {
    this.getVipLists(); return; //2022-07-30
    const { body } = await this.apiClient.base.userinfo();

    // this.setState({
    //   userinfo:body
    // })
    // this.setState({
    //   userinfo: {"id":2,"nickname":"\u6211\u8ba4\u8bc6\u4f60","realname":"","mobile":"15267286145","mobile_location":"\u6d59\u6c5f\u53f0\u5dde(\u79fb\u52a8)","avatar":"https:\/\/assets.gongji58.com\/2019-02-27\/clavmj717r1551257843.png!medium","sex":1,"type":1,"reg_ip":"223.104.246.162","point":0,"id_number":"","address":"","address_id":null,"description":"","store_name":"\u6211\u8ba4\u8bc6\u4f60","store_description":"\u6d4b\u8bd5\u4e2a\u5443\u5443\u5443","car_total":54,"want_total":3,"job_total":12,"resume_total":11,"report_total":1,"last_login":"2021-06-11 11:40:54","ban_desc":"","developer":1,"status":3,"ctime":"2019-02-27 16:57:23","utime":"2020-09-15 11:38:48","is_manager":true,"id_checks":false,"pub_total":0}
    // })

    if(!body) {
      return false;
    }
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    if(params.mode == 'ignoreArea') {
      this.getVipLists();
      console.log('ignoreArea');
      return;
    }
    
    if(body && body.area_ban) {
      //判断手机号归属地是否在禁止城市
      alert('功能升级中！')
      return false;
    }else {
      this.getVipLists()
    }

    
  }
  
}
